import { ApplicationState } from '@redux/types';
import { Config } from '@t/config';

export const getConfig = (state: ApplicationState): Config => state.config;
